import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import moment from "moment";
import DeletePopup from "../shared/delete_popup";
import AccessLocalStorage from "../../services/localStorage";
import { getApiUrl } from "../../services/api_service";
import ViewEvent from "./view_event";
import { button, carejourneytabcontainer, carejourneytabheading, eventDateTime, eventDetails, eventTitle, lightpinkcolor, pcolor, pointer, smallcircle, smallcirclemeasured, smallcircleoutgrown, smallcirclereffered, smallcirclesupplied, smallcircleusing, smallcirclewaiting } from "../../style2";

export default function SplintsandEquipments() {
  const rowsPerPageValue = 4;
  const [splintsandEquipments, setSplintsandEquipments] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageValue);
  const [viewMore, setViewMore] = useState(false);

  const [anchorEls, setAnchorEls] = useState([]);
  const [anchorPosition, setAnchorPosition] = useState(null);

  const ls = new AccessLocalStorage();
  const [openEditSplintsandEquipments, setOpenEditSplintsandEquipments] = useState(false);
  const [openViewSplintsandEquipments, setOpenViewSplintsandEquipments] = useState(false);
  const [openAddSplintsandEquipments, setOpenAddSplintsandEquipments] = useState(false);
  const [openDeletePopup, setOpenDeletePopup] = useState(false);

  const [selectedSplintsandEquipments, setSelectedSplintsandEquipments] = useState([]);

  const handleViewMore = () => {
    viewMore ? setViewMore(false) : setViewMore(true);
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(splintsandEquipments.length);
  };

  const handleMenuClick = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
    const { left, top } = event.currentTarget.getBoundingClientRect();
    setAnchorPosition({ left, top });
  };
  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
    setAnchorPosition(null);
  };
  const handleClickOpenEditSplintsandEquipments = (selectedSplintsandEquipments, index) => {
    setSelectedSplintsandEquipments(selectedSplintsandEquipments);
    setOpenEditSplintsandEquipments(true);
    //console.log("event edit id:", selectedSplintsandEquipments.id);
    handleMenuClose(index); // to close the menu after opening the edit popup
  };
  const handleClickOpenViewSplintsandEquipments = (selectedSplintsandEquipments) => {
    setSelectedSplintsandEquipments(selectedSplintsandEquipments);
    setOpenViewSplintsandEquipments(true);
    //console.log("event view id:", selectedSplintsandEquipments.id);
  };
  const handleClickAddSplintsandEquipments = () => {
    setOpenAddSplintsandEquipments(true);
  };
  const handleClickCloseSplintsandEquipments = () => {
    setOpenEditSplintsandEquipments(false);
    setOpenViewSplintsandEquipments(false);
    setOpenAddSplintsandEquipments(false);
    setSelectedSplintsandEquipments(""); // reset the selected event so the edit dialog will contain new data
  };

  const handleClickDeleteSplintsandEquipments = (id, index) => {
    handleMenuClose(index);
    setOpenDeletePopup(true);
    setSplintsandEquipments(
      splintsandEquipments.filter((SplintsandEquipments) => SplintsandEquipments.id !== id)
    );
    viewMore
      ? setRowsPerPage(rowsPerPageValue)
      : setRowsPerPage(splintsandEquipments.length);
  };

  const handleClickCloseDeletePopup = () => {
    setOpenDeletePopup(false);
  };
  // const getRandomColor = () => {
  //   const letters = '0123456789ABCDEF';
  //   let color = '#';
  //   for (let i = 0; i < 6; i++) {
  //     color += letters[Math.floor(Math.random() * 16)];
  //   }
  //   return color;
  // };
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const authTokens = localStorage.getItem("authTokens");
    let token;

    if (authTokens) {
      const parsedAuthTokens = JSON.parse(authTokens);
      token = parsedAuthTokens?.accessToken;
    }
    if (!token) {
      setError("Unauthorized. No token available.");
      setLoading(false);
      return;
    }

    fetch(
      `${getApiUrl()}${process.env.REACT_APP_GET_SPLINTSANDEQUIPMENTS
      }/${ls.getCurrentPatientId()}/${"4E67778A-8FB4-4E0F-B4E0-40DB7A979C78"}`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then((response) => response.json())
      .then((data) => {
        //console.log(data);
        setSplintsandEquipments(data);
      })
      .catch((err) => {
        setError(err.message || "An error occurred.");
        setSplintsandEquipments([]);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const renderSplintStatusName = (id) => {
    switch (id) {
      case 1:
        return <div><Box component="span" sx={smallcircle}></Box> Planned</div>;
      case 2:
        return <div><Box component="span" sx={smallcirclereffered}></Box> Referred</div>;
      case 3:
        return <div><Box component="span" sx={smallcirclemeasured}></Box> Measured</div>;
      case 4:
        return <div><Box component="span" sx={smallcirclewaiting}></Box> Waiting</div>;
      case 5:
        return <div><Box component="span" sx={smallcirclesupplied}></Box> Supplied</div>;
      case 6:
        return <div><Box component="span" sx={smallcircleusing}></Box> Using</div>;
      case 7:
        return <div><Box component="span" sx={smallcircleoutgrown}></Box> Outgrown</div>;
      default:
        return "";
    }
  }

  return (
    <Box style={{ position: "relative", padding: "0px" }}>
      <Grid container>
        <Grid item xs={11}>
          <Typography sx={carejourneytabheading}>Splints and Equipments</Typography>
        </Grid>
        {loading ? <Grid item xs={1}><CircularProgress /></Grid> : null}
      </Grid>
      <Box sx={carejourneytabcontainer}>
        {splintsandEquipments != null && splintsandEquipments.length > 0 ? splintsandEquipments.slice(0, rowsPerPage).map((SplintsandEquipments, index) => {
          return (
            <Grid
              container
              direction="row"
              alignItems="flex-start"
              key={SplintsandEquipments.id}
            >
              <Grid
                item
                xs={3}
                sx={{...eventDateTime, backgroundColor: lightpinkcolor }}
              >
                <Box component="div"
                  onClick={() => handleClickOpenViewSplintsandEquipments(SplintsandEquipments)}
                  sx={{
                    ...pointer, textAlign: "center"
                  }}
                >
                  <Typography  sx={{...eventTitle, color: pcolor }}>
                    {moment(SplintsandEquipments.startDate).format("DD.MM.YYYY")}
                  </Typography>
                  <Typography sx={{ fontSize: "14px", color: pcolor }}>
                    {moment(SplintsandEquipments.startDate).format("HH:mm A")}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                container
                item
                xs={9}
                
                alignItems="flex-start"
                justifyContent="space-between"
                sx={{...eventDetails, backgroundColor: lightpinkcolor }}
              >
                <Grid item xs={7} sm={9} md={10}>
                  <div
                    onClick={() => handleClickOpenViewSplintsandEquipments(SplintsandEquipments)}
                    style={pointer}
                  >
                    <Typography title={SplintsandEquipments.title} sx={{...eventTitle, color: pcolor }}>{SplintsandEquipments.title != null ?
                      SplintsandEquipments.title.length > 50 ? SplintsandEquipments.title.substring(0, 50) + "..." : SplintsandEquipments.title
                      : null}</Typography>
                    {renderSplintStatusName(SplintsandEquipments.splintsEquipmentStatusId)}
                    
                  </div>
                </Grid>
              </Grid>
            </Grid>
          );
        }) : loading ? null : <Box>No Splints & Equipments</Box>}
      </Box>
      <Box m={3} />
      <Grid
        container
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Grid item>
          {!viewMore && SplintsandEquipments.length > rowsPerPageValue ? (
            <Button sx={button} onClick={handleViewMore}>
              Show More
            </Button>
          ) : (
            <Box m={4} />
          )}
        </Grid>
      </Grid>
      <ViewEvent
        open={openViewSplintsandEquipments}
        handleClose={handleClickCloseSplintsandEquipments}
        eventType={"Splints and Equipments"}
        eventData={selectedSplintsandEquipments}
      />
      <DeletePopup
        open={openDeletePopup}
        handleClose={handleClickCloseDeletePopup}
      />
    </Box>
  );
}
